module.exports = __webpack_public_path__ + "img/podcasts-1.7a20aa35.png";